export type PricedSeatBandCode = '1-3' | '4-49';

export type SeatBandCode = PricedSeatBandCode | '50+';

export interface SeatBand {
  code: SeatBandCode;
  labelKey: string;
  minSeats: number;
  maxSeats: number | null;
  isEnterprise?: boolean;
}

const SMALL_TEAM_MIN_SEATS = 1;
const SMALL_TEAM_MAX_SEATS = 3;
const GROWTH_TEAM_MIN_SEATS = 4;
const GROWTH_TEAM_MAX_SEATS = 49;
const ENTERPRISE_TEAM_MIN_SEATS = 50;

export const pricedSeatBandCodes: PricedSeatBandCode[] = ['1-3', '4-49'];

export const seatBands: SeatBand[] = [
  {
    code: '1-3',
    labelKey: 'pricing:seatBands.1-3',
    minSeats: SMALL_TEAM_MIN_SEATS,
    maxSeats: SMALL_TEAM_MAX_SEATS,
  },
  {
    code: '4-49',
    labelKey: 'pricing:seatBands.4-49',
    minSeats: GROWTH_TEAM_MIN_SEATS,
    maxSeats: GROWTH_TEAM_MAX_SEATS,
  },
  {
    code: '50+',
    labelKey: 'pricing:seatBands.50+',
    minSeats: ENTERPRISE_TEAM_MIN_SEATS,
    maxSeats: null,
    isEnterprise: true,
  },
];

export const defaultSeatBand: SeatBandCode = '4-49';

export function isEnterpriseSeatBand(
  seatBandCode: SeatBandCode
): seatBandCode is '50+' {
  return seatBandCode === '50+';
}
